module.exports = __webpack_public_path__ + "static/media/PricingPage.f3822e94.jpeg";